import { CONFIGURATION_SERVICE } from "@/services/configuration.service.js";
import router from '@/router/index';

const state = { configurationOutput: {} };

const actions = {
    getConfiguration({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('getConfigurationRequest');
        CONFIGURATION_SERVICE.getConfiguration()
            .then(
                output => {
                    commit('getConfigurationSuccess', output);
                },
                error => {
                    commit('getConfigurationFailure', error);
                    dispatch('alert/error', error, { root: true });

                }
            );
    },
};

const mutations = {
        /* Get configuration */
        getConfigurationRequest(state) {
            //
        },
        getConfigurationSuccess(state, output) {
            state.configurationOutput = output;
        },
        getConfigurationFailure(state) {
            state.configurationOutput = {};

        }
}; 

export const configurations = {
    namespaced: true,
    state,
    actions,
    mutations
};